import { CssBaseline } from "@mui/material";
import React from "react";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import { createRoot } from "react-dom/client";
import "./utils/i18n";
import pkg from "../package.json";
import App from "./App";
import "./assets/fonts.css";
import * as serviceWorker from "./serviceWorker";

const BUILD_NO = import.meta.env.VITE_BUILD_NO || 0;

// Log some information
console.log(`SmarTracks Locations v${pkg.version}.${BUILD_NO}`);

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <CssBaseline />
    <App />
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
